const STORAGE_KEY = "hospitaldetails";

/** Save hospital/clinic details from login API response */
export const setHospitalDetails = (details) => {
  if (details) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(details));
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
};

/** Read hospital/clinic details saved at login */
export const getHospitalDetails = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw || raw === "[object Object]") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
